/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import {
    infraCloudStateFeatureKey,
    infraCloudStateReducer,
} from '.';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(infraCloudStateFeatureKey, infraCloudStateReducer),
    ],
    declarations: [],
})
export class IInfraCloudStateModule {}
